import React from "react";
import "./VirasatV2DefaultHomePage.scss"
import { sortByOrderAscending } from "../../helper/helper";


const VirasatV2DefaultGalleryPage = ({ components }) => {
    const getHeaderComponents = (component) => {
        switch (component.ID) {
            case "VirasatDefaultGalleryPage-subheader":
                return <div className="VirasatV2DefaultGalleryPage-header-des">- {component?.Props?.text} -</div>
            case "VirasatDefaultGalleryPage-headertext":
                return <div className="VirasatV2DefaultGalleryPage-header-title">{component?.Props?.header}
                    <div className="VirasatV2DefaultGalleryPage-header-title-hl"> {component?.Props?.highlightedHeader}</div></div>
            default:
                return <div />
        }

    }
    const headerContent = (headerComponent) => {
        return (
            <div
                className="VirasatV2DefaultGalleryPage-header"
                style={{
                    backgroundImage: ` linear-gradient(90.01deg, #192233 29.22%, rgba(82, 69, 69, 0) 169.9%), url(${headerComponent?.Props?.bgSrc})`
                }}>
                <img alt="" src={headerComponent?.Props?.leftSrc} className="VirasatV2DefaultGalleryPage-header-indimg" />
                {sortByOrderAscending(headerComponent?.Components).map((component, key) => {
                    return (
                        getHeaderComponents(component)
                    )
                })}
                <img alt="" src={headerComponent?.Props?.rightSrc} className="VirasatV2DefaultGalleryPage-header-vegimg" />

            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatDefaultGalleryPage-header":
                return headerContent(component)
            case "VirasatDefaultGalleryPage-imagegrid":
                return <div className="VirasatV2DefaultGalleryPage-container">
                    {component?.Data?.map((img, key) => {
                        return (
                            <img alt="" src={img.src} className="VirasatV2DefaultGalleryPage-container-img"
                                key={key} />

                        )
                    })}
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="VirasatV2DefaultGalleryPage"
        >
            {sortByOrderAscending(components).map((component, key) => {
                return (
                    getComponents(component)
                )
            })}

        </div>
    )

}
export default VirasatV2DefaultGalleryPage